import { combineReducers, configureStore } from '@reduxjs/toolkit'
import allReducers from './redux/reducers'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const reducers = combineReducers(
    allReducers.reducer
)

const persistConfig = {
    key: 'root',
    storage
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck:false})
})

export const clearState = (dispatch: (action:any) => void) => {
    const resetAction = { type: 'RESET_STATE' };
    dispatch(resetAction);
};

const persistor = persistStore(store);
export {persistor}

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch